import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import Duration from "./components/duration";
import "./styles.less";
import moment from "moment";
import R from "ramda";
import Ellipsis from '@/components/Ellipsis/index'
function getBase64({ data }): Promise<any> {
  return new Promise((resolve, reject) => {
    const reader: FileReader = new FileReader();
    reader.addEventListener("load", () =>
      resolve({
        data: {
          link: reader.result,
        },
      })
    );
    reader.addEventListener("error", () => reject(reader.error));
    reader.readAsDataURL(data);
  });
}

enum Types {
  create = "create",
  edit = "edit",
}

let count = 0;

@Component({
  Duration,
  Ellipsis,
})
export default class CurdForm extends Vue {
  @Prop({ default: () => [] }) readonly hidden: Array<string>;
  @Prop({ default: () => ({}) }) readonly formProps: object;
  @Prop({ default: () => true }) readonly footer: Boolean;
  @Prop({ default: () => Types.create }) readonly type: Types;
  @Prop({ default: () => ({}) }) readonly schema: object;
  @Prop({ default: () => ({}) }) readonly defaultValue: object;
  @Prop({ default: () => 12 }) readonly ellipsisLength: number;
  @Prop({ default: () => ({}) }) readonly acl: {
    save: string;
  };
  @Prop({ default: "" }) readonly resetLayout: String;

  form = null;
  cache = {};
  showUrl = "";
  id = ++count;
  multiMerge = {};
  loading = false;
  fileLists = {};

  created() {
    this.form = this.$form.createForm(this);
  }

  setLoading(bool) {
    this.loading = bool;
  }

  @Watch("defaultValue")
  onDefaultValueChange() {
    this.showUrl = "";
    this.form.resetFields();
  }

  forceUpdateOpts(options, key) {
    if (this.cache[key]) {
      return;
    }
    this.cache[key] = [];
    options().then((data) => {
      this.$set(this.cache, key, data);
      this.$forceUpdate();
    });
  }

  setOpts(options, key) {
    if (typeof options == "function") {
      this.forceUpdateOpts(options, key);
    } else {
      this.cache[key] = options;
    }
  }

  beforeUpload(file) {
    const isJpgOrPng = file.type.indexOf('image') != -1;
    if (!isJpgOrPng) {
      this.$message.error(this.$t("image_type_tip"));
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      this.$message.error(this.$t("image_size_tip"));
    }
    return isJpgOrPng && isLt2M;
  }

  handleUpload(req, key: string, async: (...args) => Promise<any>) {
    const data = {
      data: req.file,
      fileName: req.file.name,
    };

    if (!async) async = getBase64;
    async(data).then(({ data }) => {
      this.form.setFieldsValue({
        [key]: data.link,
      });
      this.showUrl = data.link;
    });
  }

  manualSubmit() {
    return new Promise((resolve, reject) => {
      this.form.validateFields((err, values) => {
        if (err) {
          reject(err);
        } else {
          resolve({
            ...R.mergeDeepRight(this.defaultValue, values),
            ...this.multiMerge,
          });
        }
      });
    });
  }

  resetForm(){
    this.form.resetFields();
  }

  manualSubmitWithLoading() {
    return this.manualSubmit().then((data) => {
      return [data, this.setLoading.bind(this)];
    });
  }

  onSubmit(e) {
    e.preventDefault();
    this.manualSubmit()
      .then((data) => {
        this.emitSubmit(data);
      })
      .catch((err) => {});
  }

  // @Emit("submit")
  emitSubmit(values) {
    this.$emit("submit", values, this.setLoading.bind(this));
    // return values;
  }

  @Emit("cancel")
  onCancel() {}

  renderFooter() {
    if (!this.footer) return null;
    const children = [
      <a-button style="margin-right: 10px;" onClick={this.onCancel}>
        {this.$t("cancel")}
      </a-button>,
      <a-button
        v-acl={this.acl.save}
        type="primary"
        onClick={this.onSubmit}
        loading={this.loading}
      >
        {this.$t("save")}
      </a-button>,
    ];
    return (
      <a-form-item wrapperCol={{ span: 10, offset: 14 }}>
        {children}
      </a-form-item>
    );
  }

  getRenderMethod(t) {
    let type = t;
    if (typeof type === "function") {
      type = type(this.form.getFieldsValue());
    }
    return `render${type.charAt(0).toUpperCase() + type.slice(1)}`;
  }

  setInitialValue(key, { type, options }) {
    let res;
    const keys = key.split(".");
    if (keys.length === 1) res = this.defaultValue[key];
    res = keys.reduce((curr, path) => curr && curr[path], this.defaultValue);
    if (type === "radio" && res === undefined)
      res = options[0] && options[0].value;
    return res;
  }

  transferValues(value, key) {
    const keys = key.split(".");
    const length = keys.length;

    if (length === 1) return;
    keys.reduce((curr, path, index) => {
      if (index < length - 1) {
        return curr[path] || (curr[path] = {});
      } else {
        return (curr[path] = value[key]);
      }
    }, value);
    delete value[key];
  }

  renderFormItem(key) {
    const {
      defaultValue,
      type,
      label,
      placeholder,
      labelCol,
      wrapperCol,
      rules,
      props,
      display,
      on = {},
      without,
      customStyle = {},
      render: _r,
      append = null,
      style: compStyle,
      ...rest
    } = this.schema[key];
    const _without = transferStaticToFunc(without);
    if (_without(this.form.getFieldsValue())) return null;

    let style: any = {};
    style= {
      display:display
    }
    if (this.hidden.includes(key)) style.display = "none";
    const renderMethod = this.getRenderMethod(type);
    let dfValue = this.setInitialValue(key, this.schema[key]) ? this.setInitialValue(key, this.schema[key]) : defaultValue;
    if (this.schema[key].type === 'radio' && !dfValue) {
      dfValue = 0
    }
    const vDecorator = [
      key,
      {
        rules: rules,
        initialValue: dfValue,
      },
    ];

    const options = {
      directives: [
        {
          name: "decorator",
          value: vDecorator,
        },
      ],
      props: props,
      on: on,
      style: compStyle,
      placeholder: placeholder,
    };

    let render;
    if (renderMethod === "renderText") {
      render = this.renderText(dfValue, key);
    } else {
      render = this[renderMethod](options, key, rest);
    }

    return (
      <a-form-item
        style={{
          ...customStyle,
          ...style,
        }}
        wrapperCol={wrapperCol}
        labelCol={labelCol}
        label={ 
          <ellipsis tooltip length={this.ellipsisLength}>
            {label}
          </ellipsis>
         }
        // key={`${Date.now()}${key}`}
      >
        {render}
      </a-form-item>
    );
  }

  beforeUploadFile(key) {
    return (...args) => {
      return false;
    };
  }

  changeUploadfile(key) {
    return ({ file, fileList }) => {
      this.fileLists[key] = [file];
    };
  }

  renderUploadFile(options, key) {
    return (
      // <a-upload
      //   name="file"
      //   multiple={false}
      //   fileList={this.fileLists[key]}
      //   beforeUpload={this.beforeUploadFile(key)}
      //   showUploadList={{
      //     showPreviewIcon: true,
      //     showRemoveIcon: false,
      //   }}
      //   onChange={this.changeUploadfile(key)}
      //   {...options}
      // >
      //   <a-button>
      //     <a-icon type="upload" /> {this.$t("page_dform_click_upload")}{" "}
      //   </a-button>
      // </a-upload>
      <upload
        simple
        fileList={this.fileLists[key]}
        onChange={this.changeUploadfile(key)}
        {...options}
      />
    );
  }

  renderUpload(options, key, rest = {}) {
    const { async } = rest as any;
    const defaultValue = this.showUrl || this.defaultValue[key];
    return (
      <a-upload
        class="avatar-uploader"
        listType="picture-card"
        showUploadList={false}
        beforeUpload={this.beforeUpload}
        customRequest={(req) => this.handleUpload(req, key, async)}
        {...options}
        sty
      >
        {defaultValue ? (
          <img src={defaultValue} class="avatar-preview" />
        ) : (
          <div>
            <a-icon type="plus" />
            <div class="ant-upload-text">Upload</div>
          </div>
        )}
      </a-upload>
    );
  }

  renderRadio(options, key?, rest?) {
    console.log("options:{}", options)
    const { props: { radioStyle = {} } = {} } = options;
    let { disabled } = rest;
    disabled = this.type == Types.edit && disabled;
    const { options: opts = [] } = rest;
    const cache = options.on.change || (() => {});
    options.on.change = e => {
      cache(e, this.form, opts);
    };

    return (
      <a-radio-group {...options} disabled={disabled}>
        {opts.map(({ label, value }) => (
          <a-radio value={value} style={radioStyle}>
            {label}
          </a-radio>
        ))}
      </a-radio-group>
    );
  }

  renderInput(options, key?, rest?) {
    let { disabled } = rest;
    disabled = this.type == Types.edit && disabled;
    options.props = {
      disabled: disabled,
      ...options.props,
    };
    return <a-input {...options} placeholder={options.placeholder}></a-input>;
  }

  renderText(value, key) {
    const { customRender } = this.schema[key];
    if (customRender) return customRender(value);
    return <span class="ant-form-text">{value}</span>;
  }

  renderDuration(options, key?, rest?) {
    return (
      <div>
        <Duration {...options} />
      </div>
    );
  }

  renderInputNumber(options, key?, rest?) {
    let { disabled } = rest;
    disabled = this.type == Types.edit && disabled;
    return <a-input-number {...options} disabled={disabled} placeholder={options.placeholder}></a-input-number>;
  }

  renderTextarea(options, key?, rest?) {
    return <a-textarea {...options} placeholder={options.placeholder}></a-textarea>;
  }

  renderPassword(options, key?, rest?) {
    return <a-input-password {...options} placeholder={options.placeholder}></a-input-password>;
  }

  renderSwitch(options, key?, rest?) {
    const vDecorator = options.directives[0].value;
    vDecorator[1]['valuePropName'] = 'checked';
    return <a-switch {...options}></a-switch>;
  }

  renderDatePicker(options, key?, rest?) {
    const vDecorator = options.directives[0].value;
    const initialValue = vDecorator[1].initialValue;
    if (initialValue) {
      vDecorator[1].initialValue = moment(initialValue);
    }
    return <a-date-picker {...options} format="YYYY-MM-DD" placeholder={options.placeholder}></a-date-picker>;
  }

  setMultiKeys(multiKeys, value, opts) {
    const isObject = multiKeys.toString() === "[object Object]";
    const keys = isObject ? Object.keys(multiKeys) : multiKeys;
    if (keys && keys.length) {
      const find = opts.find((opt) => opt.value == value);
      if (!find.rest) return;
      for (let key of keys) {
        const mapKey = isObject ? multiKeys[key] : key;
        this.multiMerge[key] = find.rest[mapKey];
      }
    }
  }

  renderTreeSelect(options, key?, rest?) {
    this.setOpts(rest.options, key);
    const opts = this.cache[key];

    let { disabled } = rest;
    disabled = this.type == Types.edit && disabled;

    return (
      <a-tree-select
        {...options}
        disabled={disabled}
        treeData={opts}
        placeholder={options.placeholder}
      ></a-tree-select>
    );
  }
  filterOption(input, option) {
    return (
      option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  }

  renderSelect(options, key?, rest?) {
    this.setOpts(rest.options, key);
    const opts = this.cache[key];

    let { disabled } = rest;
    disabled = this.type == Types.edit && disabled;
    const { multiKeys } = rest;
    const cache = options.on.change || (() => {});
    options.on.change = (value) => {
      cache(value, this.form, opts);
      if (multiKeys) this.setMultiKeys(multiKeys, value, opts);
    };

    return (
      <a-select {...options} disabled={disabled} showSearch filterOption={this.filterOption} placeholder={options.placeholder}>
        {opts.map(({ label, value }) => (
          <a-select-option value={value}>{label}</a-select-option>
        ))}
      </a-select>
    );
  }

  render() {
    let compontents = [];
    let keys = Object.keys(this.schema);
    let key;
    if (this.resetLayout) {
      const cols = this.resetLayout.split(":");
      let count = 0;
      compontents = cols.map((col: any) => {
        col = Number(col);
        return (
          <a-row gutter={24}>
            {[...new Array(col)].map(() => {
              key = keys[count++];
              return key ? (
                <a-col span={24 / col}>{this.renderFormItem(key)}</a-col>
              ) : null;
            })}
          </a-row>
        );
      });
    } else {
      keys.map((key) => {
        compontents.push(this.renderFormItem(key));
      });
    }

    return (
      <div class="baseform-wrapper">
        <a-form
          form={this.form}
          label-col={{ span: 6 }}
          wrapper-col={{ span: 16 }}
          {...{ props: this.formProps }}
        >
          {compontents}
        </a-form>
        {this.renderFooter()}
      </div>
    );
  }
}

const transferStaticToFunc = (fn) => {
  if (typeof fn === "function") return fn;
  return () => fn;
};
